export default __webpack_public_path__ + "static/media/capsule-draft.8631bb50.png";